module.exports = __webpack_public_path__ + "media/images/application/favicon/logo-c8abe1c1c7c2bdc565ba27e3b841b008.png";